// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.company-score-chart-container {
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}

.company-score-chart-wrapper {
  width: 100%;
  aspect-ratio: 4 / 3;
  min-height: 150px;
  max-height: 250px;
}

.company-score-analysts-rating-container {
  background-color: var(--surface-tertiary);
}

.company-score-tooltip-title {
  white-space: nowrap;
}

.company-score-tooltip-row {
  display: flex;
  justify-content: space-between;
  margin: 2px 0;
  font-size: 11px;
}
.company-score-tooltip-value {
  text-align: right;
  font-weight: bold;
}

.company-score-tooltip-label::before {
  content: '• ';
  font-weight: bold;
}

.company-score-tooltip {
  width: max-content;
  min-width: 220px;
  white-space: normal;
  position: relative;
  padding: 12px;
  border-radius: 6px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border: 1px solid var(--border-primary);
  background: var(--surface-primary);
  display: none;
}

.company-score-tooltip-inner::after {
  content: '';
  position: absolute;
  top: -6px;
  left: 50%;
  transform: translateX(-50%);
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  border-bottom: 7px solid var(--border-primary);
  z-index: 1002;
}

.company-score-tooltip-inner::before {
  content: '';
  position: absolute;
  top: -8px;
  left: 50%;
  transform: translateX(-50%);
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-bottom: 8px solid var(--border-primary);
  z-index: 1001;
}
`, "",{"version":3,"sources":["webpack://./src/Components/CompanyScoreChart/CompanyScoreChart.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,aAAa;EACb,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,wCAAwC;EACxC,uCAAuC;EACvC,kCAAkC;EAClC,aAAa;AACf;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,kCAAkC;EAClC,mCAAmC;EACnC,8CAA8C;EAC9C,aAAa;AACf;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,kCAAkC;EAClC,mCAAmC;EACnC,8CAA8C;EAC9C,aAAa;AACf","sourcesContent":[".company-score-chart-container {\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n}\n\n.company-score-chart-wrapper {\n  width: 100%;\n  aspect-ratio: 4 / 3;\n  min-height: 150px;\n  max-height: 250px;\n}\n\n.company-score-analysts-rating-container {\n  background-color: var(--surface-tertiary);\n}\n\n.company-score-tooltip-title {\n  white-space: nowrap;\n}\n\n.company-score-tooltip-row {\n  display: flex;\n  justify-content: space-between;\n  margin: 2px 0;\n  font-size: 11px;\n}\n.company-score-tooltip-value {\n  text-align: right;\n  font-weight: bold;\n}\n\n.company-score-tooltip-label::before {\n  content: '• ';\n  font-weight: bold;\n}\n\n.company-score-tooltip {\n  width: max-content;\n  min-width: 220px;\n  white-space: normal;\n  position: relative;\n  padding: 12px;\n  border-radius: 6px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  border: 1px solid var(--border-primary);\n  background: var(--surface-primary);\n  display: none;\n}\n\n.company-score-tooltip-inner::after {\n  content: '';\n  position: absolute;\n  top: -6px;\n  left: 50%;\n  transform: translateX(-50%);\n  border-left: 7px solid transparent;\n  border-right: 7px solid transparent;\n  border-bottom: 7px solid var(--border-primary);\n  z-index: 1002;\n}\n\n.company-score-tooltip-inner::before {\n  content: '';\n  position: absolute;\n  top: -8px;\n  left: 50%;\n  transform: translateX(-50%);\n  border-left: 8px solid transparent;\n  border-right: 8px solid transparent;\n  border-bottom: 8px solid var(--border-primary);\n  z-index: 1001;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
